import { useDeferredValue, useMemo, useState } from "react";
import type { TaskLog } from "@/contracts/tasks";
import {
  countLogLevels,
  createDisplayRows,
  filterLogs,
  type LogLevelFilter,
} from "../model/task-log-view";

export function useTaskLogView(logs: readonly TaskLog[]) {
  const [query, setQuery] = useState("");
  const deferredQuery = useDeferredValue(query.trim());
  const [level, setLevel] = useState<LogLevelFilter>("all");
  const levelCounts = useMemo(() => countLogLevels(logs), [logs]);
  const filteredLogs = useMemo(
    () => filterLogs(logs, level, deferredQuery),
    [logs, deferredQuery, level],
  );
  const displayRows = useMemo(() => createDisplayRows(filteredLogs), [filteredLogs]);

  return {
    deferredQuery,
    displayRows,
    filteredLogs,
    level,
    levelCounts,
    query,
    setLevel,
    setQuery,
  };
}
